<template>
  <section>
    <div class="level item-information-column-direction">
      <div class="level-item has-text-centered" style="justify-content: space-between">
        <div style="display: flex; justify-content: space-around; width: 45%">
          <div class="margin-2">
            <p class="heading">Fornecedor</p>
            <p>
              <strong>{{ item.identificador }}</strong>
            </p>
          </div>
          <div class="margin-2">
            <p class="heading">Descrição</p>
            <p class="description-text" ref="description-text">
              <strong>{{ item.item.descricao }}</strong>
            </p>
          </div>
          <div class="margin-2">
            <p class="heading">Fornecedor</p>
            <p class="description-text" ref="description-text">
              <strong>{{ batchProposals[0].apelido }}</strong>
            </p>
          </div>
          <div class="margin-2">
            <p class="heading">{{ columnName }}</p>
            <p class="description-text" ref="description-text">
              <strong>{{ totalFormatado }}</strong>
            </p>
          </div>
        </div>

        <div class="margin-2">
          <button class="button is-primary" @click="$emit('voltar')">Voltar</button>
        </div>
      </div>
    </div>
    <b-loading is-full-page :active="loading">
      <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin"></b-icon>
    </b-loading>
    <b-table
      v-if="!loading && batchProposals.length"
      class="table is-fullwidth proposals-table"
      hoverable
      :data="batchProposals"
    >
      <b-table-column centered label="ID" v-slot="props">
        {{ props.row.id }}
      </b-table-column>
      <b-table-column centered label="Descrição" v-slot="props">
        {{ props.row.descricao }}
      </b-table-column>
      <b-table-column centered label="Unidade" v-slot="props">
        {{ props.row.unidade }}
      </b-table-column>
      <b-table-column centered label="Quantidade" v-slot="props">
        {{ props.row.quantidade }}
      </b-table-column>
      <b-table-column centered :visible="!!displayValueColumn" label="Valor" v-slot="props">
        {{
          !maiorDesconto
            ? formatarValor(Number(props.row.valor))
            : formatarValor(calcularValorDePorcentagem(item.total, props.row.percentual))
        }}
      </b-table-column>
      <b-table-column :visible="maiorDesconto" centered label="Percentual" v-slot="props">
        {{ maiorDesconto ? `${formatarPorcentagem(props.row.percentual)}%` : 0 }}
      </b-table-column>
      <b-table-column centered label="Marca" v-slot="props">
        {{ props.row.marca }}
      </b-table-column>
      <b-table-column centered label="Fabricado" v-slot="props">
        {{ converteFabricado(props.row.fabricado) }}
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { formatarValor, formatarPorcentagem } from '@/utils/format';
import { calcularValorDePorcentagem } from '@/utils/calculations';

export default {
  name: 'BatchProposalViewer',
  props: {
    batchProposals: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    maiorDesconto: {
      type: Boolean,
      default: false,
    },
    displayValueColumn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('proposals', {
      propostas: 'proposals',
    }),
    columnName() {
      return this.maiorDesconto ? 'Total Percentual' : 'Total Valor';
    },
    totalFormatado() {
      if (this.maiorDesconto) {
        const totalPercentual = this.batchProposals.reduce((total, proposta) => {
          const percentual = parseFloat(proposta.percentual || 0);
          return total + percentual;
        }, 0);

        return `${totalPercentual}%`;
      }
      const totalValor = this.batchProposals.reduce((total, proposta) => {
        const valor = parseFloat(proposta.valor || 0);
        return total + valor;
      }, 0);

      return (
        totalValor.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }) || 'R$ 0,00'
      );
    },
  },
  methods: {
    formatarValor,
    formatarPorcentagem,
    calcularValorDePorcentagem,
    converteFabricado(fabricado) {
      return fabricado === 'BRASIL' ? 'Não' : 'Sim';
    },
  },
};
</script>
